import { useAppSelector } from 'app/hooks';
import { DUCTED_PATHWAY_SYSTEM_PREFERENCES } from 'utils/project';

// Reactive equivalent of utils/project's isDuctedPathway() (which reads the
// store singleton imperatively): components gating render/fetch behavior on
// the ducted pathway must re-render when system_preference changes.
export default function useIsDuctedPathway(): boolean {
  return useAppSelector((state) =>
    DUCTED_PATHWAY_SYSTEM_PREFERENCES.includes(
      state.project.projectSettings.find(
        (ps) => ps.code === 'system_preference'
      )?.value
    )
  );
}
